import { createContext, useContext, useCallback } from "react";
import api from "../api.js";

const PatientsContext = createContext(null);

// Thin wrapper around create/delete only — there used to be a full unpaginated patient list kept
// here and preloaded on every app start, but that stops scaling once the roster gets large.
// Callers that need a list now search/paginate on demand via api.listPatients() directly.
export function PatientsProvider({ children }) {
  const addPatient = useCallback(async (form) => api.createPatient(form), []);
  const removePatient = useCallback(async (id) => api.deletePatient(id), []);

  return (
    <PatientsContext.Provider value={{ addPatient, removePatient }}>
      {children}
    </PatientsContext.Provider>
  );
}

export const usePatients = () => useContext(PatientsContext);
